const parentChildActions = {
    types: {
        CHILD_ASSESSMENT_ITEM_LOAD_SUCCESS: 'CHILD_ASSESSMENT_ITEM_LOAD_SUCCESS',
        CHILD_TEST_SETTINGS_LOAD_SUCCESS: 'CHILD_TEST_SETTINGS_LOAD_SUCCESS',
        CHILD_ASSESSMENT_ITEM_LOAD_FAILED: 'CHILD_ASSESSMENT_ITEM_LOAD_FAILED',
        CHILD_TEST_SETTINGS_LOAD_FAILED: 'CHILD_TEST_SETTINGS_LOAD_FAILED',
        REMOVE_PENDING_ASSESSMENT: 'REMOVE_PENDING_ASSESSMENT',
    },

    childAssessmentItemLoadSuccess(identifier, assessment) {
        return {
            type: this.types.CHILD_ASSESSMENT_ITEM_LOAD_SUCCESS,
            body: {
                assessmentItem: assessment,
            },
            identifier,
        };
    },
    childAssessmentItemLoadFailed(identifier, error) {
        return {
            type: this.types.CHILD_ASSESSMENT_ITEM_LOAD_FAILED,
            body: {
                error,
            },
            identifier,
        };
    },
    childTestSettingsLoadSuccess(identifier, settings) {
        return {
            type: this.types.CHILD_TEST_SETTINGS_LOAD_SUCCESS,
            body: {
                settings,
            },
            identifier,
        };
    },
    childTestSettingsLoadFailed(identifier, error) {
        return {
            type: this.types.CHILD_TEST_SETTINGS_LOAD_FAILED,
            body: {
                error,
            },
            identifier,
        };
    },
    removePendingAssessment(identifier) {
        return {
            type: this.types.REMOVE_PENDING_ASSESSMENT,
            identifier,
        };
    },
};

export default parentChildActions;
